import { Department } from '@/modules/department'
import { User } from '@/modules/user'
import { BaseResource, PpUserRole, PriorityEnum, ResourcePermission, ResourceType, Team } from '@/schemas'

import { DimensionType } from '../dimensions'

export enum ReviewFormActions {
  创建 = 0,
  通过 = 1,
  驳回 = 2,
  完成 = 3,
}

export const CustomerRole = {
  负责人: '负责人',
  销售Owner: '销售Owner',
  服务Owner: '服务Owner',
  产品经理: '产品经理',
  项目经理: '项目经理',
  TO: 'TO',
  子TO: '子TO',
  成员: '成员',
} as const

export enum CustomerFlowStatus {
  待研发审批 = 'DevWaitForAudit',
  研发未开始 = 'DevNotStarted',
  项目已驳回 = 'ProjectRejected',
  研发进行中 = 'DevOnGoing',
  研发暂停中 = 'DevPending',
  项目已取消 = 'ProjectCanceled',
  待客户验收 = 'CustomerWaitForValidate',
  // 待客户上线 = 'CustomerWaitForRelease',
  结果追踪中 = 'ResultTracking',
  // 待上线确认 = 'ReleaseWaitForConfirm',
  结果复核中 = 'ResultReviewing',
  待项目结项 = 'ProjectWaitForFinish',
  项目已结项 = 'ProjectFinished',
  项目已失败 = 'ProjectFailed',
}

export const CustomerTerminateFlowStatus = [
  CustomerFlowStatus.项目已驳回,
  CustomerFlowStatus.项目已结项,
  CustomerFlowStatus.项目已失败,
  CustomerFlowStatus.项目已取消,
] as const

export interface Customer extends BaseResource, ResourcePermission {
  id: number
  selfId: string
  name: string
  email: string
  emailChangeReason: string | null
  departmentId: number
  type: number
  level: string
  to: string
  pgm: string
  pm: string
  flowStatus: CustomerFlowStatus
  startDate: Date
  endDate: Date
  startDateChangeReason: string | null
  endDateChangeReason: string | null
  progress: number
  important: string
  businessGoal: string
  businessGoalChangeReason: string | null
  deliveryTime: Date | null
  expectTime: string
  expectTimeChangeReason: string | null
  dependencies: string
  priority: PriorityEnum
  priorityChangeReason: string | null
  jql: string | null
  dimensions: {
    id: number
    projectSelfId: string
    resourceType: ResourceType
    dimensionId: number
    percentage: number
    dimension: {
      id: number
      name: string
      type: DimensionType
    }
  }[]

  thisWeekReport: any

  readPermissions?: string[]

  background: string
  goal: string
  goalChangeReason: string | null
  standard: string
  standardChangeReason: string | null

  createdAt: Date
  updatedAt: Date
  deletedAt?: any
  typeName: string
  user: User
  department: Department
  cycle: Cycle

  isFavourited: boolean

  risk: any
  lastestWrite: any
  resources: CustomerEstimateResource[]
  businessReport?: {
    report: string
    createTime: string
  }
  hots: any[]
  roles: PpUserRole[]
  flows: CustomerFLow[]
  historyRecords: HistoryRecord[]
  region?: string
  expectValidationTime?: string
  predictWorkload?: number
  actualWorkload?: number
  permissions: any[]
}

export interface HistoryRecord {
  key: string
  updateType: 'init' | 'update'
  type: 'history' | 'flow'
  currentValue: string | null
  email?: string
  beforeValue: string | null
  createdAt: string
  additions: CustomerFLowAddition[]
}

export interface CustomerFLow {
  id: number
  prevId: number | null
  status: CustomerFlowStatus
  createdAt: Date
  email?: string
  additions: CustomerFLowAddition[]
}

export interface CustomerFLowAddition {
  id: number
  customerFlowId: number
  type: string
  value: string
}
export interface CustomerEstimateResourceUser {
  estimateResourceId: number
  email: string
}

export interface CustomerEstimateResource {
  id: number
  teamSelfId: string
  workload: number
  startDate: string
  endDate: string
  department?: Team
  users?: CustomerEstimateResourceUser[]
}

interface Cycle {
  name: string
  cycleId: number
}

export enum CustomerWaitForValidateReason {
  NotQualified = 'NotQualified',
  CustomerPriorityDecreased = 'CustomerPriorityDecreased',
  ExtendedCustomerTestingCycle = 'ExtendedCustomerTestingCycle',
  CustomerRequirementsChanged = 'CustomerRequirementsChanged',
  Other = 'Other',
}

export const OverseaRegion = 'US&ROW' as const
